import { createAction } from '@reduxjs/toolkit';

export const syncWithStorage = createAction<void>('SYNC_WITH_STORAGE_ACTION');
export const SYNC_WITH_STORAGE_ACTION = syncWithStorage.toString();
